
export default {
  props: {
    items: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultImageUrl:
        'https://static.vecteezy.com/system/resources/previews/004/141/669/original/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg',
    }
  },

  methods: {
    limitarTexto(texto, limite) {
      if (texto.length > limite) {
        return texto.slice(0, limite) + '..'
      } else {
        return texto
      }
    },
    getNewsImage(items) {
      if (
        items.better_featured_image &&
        items.better_featured_image.source_url
      ) {
        return items.better_featured_image.source_url
      } else {
        return this.defaultImageUrl // Retorna a URL da imagem padrão se a imagem for nula
      }
    },
    acessar() {
      this.$router.push(`/blog/${this.items.slug}`)
    },
  },
}
